import axios from "axios"

export default (responseType) => axios.create({
  baseURL: process.env.API_URL,
  withCredentials: true,
  timeout: 900000, // 15 minute timeout
  responseType
});
